// src/Services/endpoints.js
const endpointsAdmin = {
  users: {
    getAll: '/api/users',
    getById: (id) => `/api/users/getbyid/${id}`,
    create: '/api/users/insert',
    login: '/api/users/login',
    loginSuperAdmin: '/api/users/login/superadmin',
    loginAdminmitra: '/api/users/login/adminmitra',
    loginAdminmitraByLembaga: (id_lembaga) => `/api/users/login/adminmitra/${id_lembaga}`,
    update: (id) => `/api/users/update/${id}`,
    delete: (id) => `/api/users/delete/${id}`,
  },

  himpun: {
    getAll: '/api/himpun',
    getById: (id) => `/api/himpun/get/${id}`,
    create: '/api/himpun/insert',
    login: '/api/himpun/login',
    update: (id) => `/api/himpun/update/${id}`,
    delete: (id) => `/api/himpun/delete/${id}`,
  },

  donatur: {
    getAll: '/api/donatur',
    getById: (id) => `/api/donatur/get/${id}`,
    create: '/api/donatur/insert',
    login: '/api/donatur/login',
    update: (id) => `/api/donatur/update/${id}`,
    delete: (id) => `/api/donatur/delete/${id}`,
  },

  transaksi: {
    getAll: '/api/transaksi',
    getById: (id) => `/api/transaksi/get/${id}`,
    getByDonatur: (idDonatur) => `/api/transaksi/donatur/${idDonatur}`,
    getByKodeDonatur: (kd_donatur) => `/api/transaksi/by-donatur/${kd_donatur}`,
    create: '/api/transaksi/insert',
    login: '/api/transaksi/login',
    update: (id) => `/api/transaksi/update/${id}`,
    delete: (id) => `/api/transaksi/delete/${id}`,
  },

  konfirmasi_transaksi: {
    getAll: '/api/konfirmasi-transaksi',
    getById: (id) => `/api/konfirmasi-transaksi/get/${id}`,
    getByTransaksi: (id_transaksi) => `/api/konfirmasi-transaksi/by-transaksi/${id_transaksi}`,
    create: '/api/konfirmasi-transaksi/insert',
    update: (id) => `/api/konfirmasi-transaksi/update/${id}`,
    delete: (id) => `/api/konfirmasi-transaksi/delete/${id}`,
  },

  jenis_donasi: {
    getAll: '/api/jenis-donasi',
    getById: (id) => `/api/jenis-donasi/get/${id}`,
    create: '/api/jenis-donasi/insert',
    update: (id) => `/api/jenis-donasi/update/${id}`,
    delete: (id) => `/api/jenis-donasi/delete/${id}`,
  },

  detail_donasi: {
    getAll: '/api/detail-donasi',
    getById: (id) => `/api/detail-donasi/get/${id}`,
    create: '/api/detail-donasi/insert',
    update: (id) => `/api/detail-donasi/update/${id}`,
    delete: (id) => `/api/detail-donasi/delete/${id}`,
  },

  qrcode: {
    getAll: '/api/qrcode',
    getActive: '/api/qrcode/active',
    generate: '/api/qrcode/generate',
    getById: (id) => `/api/qrcode/get/${id}`,
    create: '/api/qrcode/insert',
    update: (id) => `/api/qrcode/update/${id}`,
    delete: (id) => `/api/qrcode/delete/${id}`,
  },

  penyaluran_program: {
    getAll: '/api/penyaluran-program',
    getByProgram: (idProgram) => `/api/penyaluran-program/by-program/${idProgram}`,
    getByMahasiswa: (idMahasiswa) => `/api/penyaluran-program/by-mahasiswa/${idMahasiswa}`,
    getByDataPengajuan: (idDataPengajuan) => `/api/penyaluran-program/by-data-pengajuan/${idDataPengajuan}`,
    getByUser: (idUser) => `/api/penyaluran-program/by-user/${idUser}`,
    getById: (id) => `/api/penyaluran-program/get/${id}`,
    create: '/api/penyaluran-program/insert',
    update: (id) => `/api/penyaluran-program/update/${id}`,
    delete: (id) => `/api/penyaluran-program/delete/${id}`,
  },

  data_pengajuan: {
    getAll: '/api/data-pengajuan',
    getById: (id) => `/api/data-pengajuan/get/${id}`,
  },

  dokumen_pengajuan: {
    getAll: '/api/dokumen-pengajuan',
    getById: (id) => `/api/dokumen-pengajuan/get/${id}`,
  },

  jenis_foto: {
    getAll: '/api/jenis-foto',
    getById: (id) => `/api/jenis-foto/get/${id}`,
  },

  tbl_foto: {
    getAll: '/api/foto-pengajuan',
    getById: (id) => `/api/foto-pengajuan/get/${id}`,
  },

  informasi: {
    getAll: '/api/informasi-mahasiswa',
    getById: (id) => `/api/informasi-mahasiswa/get/${id}`,
    create: '/api/informasi-mahasiswa/insert',
    update: (id) =>  `/api/informasi-mahasiswa/update/${id}`,
    delete: (id) => `/api/informasi-mahasiswa/delete/${id}`,
  },

  program: {
    getAll: '/api/program',
    getById: (id) => `/api/program/get/${id}`,
    create: '/api/program/insert',
    update: (id) => `/api/program/update/${id}`,
    delete: (id) => `/api/program/delete/${id}`,
  },

  divisi: {
    getAll: '/api/divisi',
    getById: (id) => `/api/divisi/get/${id}`,
    create: '/api/divisi/insert',
    update: (id) => `/api/divisi/update/${id}`,
    delete: (id) => `/api/divisi/delete/${id}`,
  },

  lembaga: {
    getAll: '/api/lembaga',
    getById: (id) => `/api/lembaga/get/${id}`,
    create: '/api/lembaga/insert',
    update: (id) => `/api/lembaga/update/${id}`,
    delete: (id) => `/api/lembaga/delete/${id}`,
  },

  detail_himpun: {
    getAll: '/api/detail-himpun',
    getById: (id) => `/api/detail-himpun/get/${id}`,
    create: '/api/detail-himpun/insert',
    update: (id) => `/api/detail-himpun/update/${id}`,
    delete: (id) => `/api/detail-himpun/delete/${id}`,
  },

  pengeluaran: {
    getAll: '/api/pengeluaran',
    getById: (id) => `/api/pengeluaran/get/${id}`,
    create: '/api/pengeluaran/insert',
    update: (id) => `/api/pengeluaran/update/${id}`,
    delete: (id) => `/api/pengeluaran/delete/${id}`,
  },

  detail_pengeluaran: {
    getAll: '/api/detail-pengeluaran',
    getById: (id) => `/api/detail-pengeluaran/get/${id}`,
    create: '/api/detail-pengeluaran/insert',
    update: (id) => `/api/detail-pengeluaran/update/${id}`,
    delete: (id) => `/api/detail-pengeluaran/delete/${id}`,
  },

  jenis_beban: {
    getAll: '/api/jenis-beban',
    getById: (id) => `/api/jenis-beban/get/${id}`,
    create: '/api/jenis-beban/insert',
    update: (id) => `/api/jenis-beban/update/${id}`,
    delete: (id) => `/api/jenis-beban/delete/${id}`,
  },

  zakat: {
    getAll: '/api/zakat',
    getById: (id) => `/api/zakat/get/${id}`,
    create: '/api/zakat/insert',
    update: (id) => `/api/zakat/update/${id}`,
    delete: (id) => `/api/zakat/delete/${id}`,
  },

  adminmitra: {
    create: '/api/adminmitra',
    createByLembaga: (id_lembaga) => `/api/adminmitra/${id_lembaga}`,
  },

  riwayat_pengajuan: {
    getAll: '/api/riwayat-pengajuan',
    getByLembaga: (id_lembaga) => `/api/riwayat-pengajuan/lembaga/${id_lembaga}`,
    getById: (id) => `/api/riwayat-pengajuan/get/${id}`,
    create: '/api/riwayat-pengajuan/insert',
    update: (id) => `/api/riwayat-pengajuan/update/${id}`,
    delete: (id) => `/api/riwayat-pengajuan/delete/${id}`,
  },
};

export default endpointsAdmin;
